// removed by extract-text-webpack-plugin
module.exports = {"solidline-grey":"UnauthAccess__solidline-grey","solidlineGrey":"UnauthAccess__solidline-grey","content18px":"UnauthAccess__content18px","content18Px":"UnauthAccess__content18px","content24px":"UnauthAccess__content24px","content24Px":"UnauthAccess__content24px","link-text-decoration":"UnauthAccess__link-text-decoration","linkTextDecoration":"UnauthAccess__link-text-decoration","message-text":"UnauthAccess__message-text","messageText":"UnauthAccess__message-text","link-width":"UnauthAccess__link-width","linkWidth":"UnauthAccess__link-width"};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idse/cart-ui/components/CommonCart/common/UnauthAccess/UnauthAccess.scss
// module id = 2315
// module chunks = 8